import React from 'react';

import AddUserAddressModal from "./ExhibitionAddUserAddressModal"
import CardComponent from "./ExhibitionArtworkCardComponent";
import Carousel from "../Carousel/MediaCarouselComponent";

import back from '../Resources/left-arrow.svg';
import map from '../Resources/homepage/map.svg';
import exhibition from '../Resources/homepage/exhibition.svg';
import extendedExperience from '../Resources/homepage/extendedExperience.svg';
import ErrorComponent from '../ErrorComponents/GenericErrorComponents';

import { Row, Col, Button, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import moment from 'moment';
import { toast } from "react-toastify";
import { v4 as uuidv4 } from 'uuid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import FileService from "../../../services/file.service";
import UserService from "../../../services/user.service";
import ApiService from '../../../services/api.service';
import { translatedMessage } from '../../../services/language.service';
import ArtworkService from '../../../services/artwork.service';
import PaymentService from '../../../services/payment.service';

class ExhibitionViewComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      exhibitionId: this.props.exhibitionId,
      exhibition: null,
      location: {
        id: 0,
        locationLat: 0,
        locationLng: 0,
        radius: 0,
        name: ''
      },
      hasLocation: false,
      user: {},
      profile: {},
      membership: {},
      accessDetails: null,
      isLoaded: false,
      addressDialogVisible: false,
      ticket: {},
      hasTicket: false,
      errorMessage: '',
      isError: false,
      carouselMedia: [],
      freeArtworks: []
    };
  }

  componentDidMount = () => {
    let user = ApiService.getCurrentUser();
    if (!user) {
      ApiService.initCurrentUser()
        .then(response => {
          this.setState({
            user: response
          }, this.loadData)
        })
    } else {
      this.setState({ user: user }, this.loadData)
    }
  }

  loadData = () => {
    let exhibition = null;
    let hasLocation = false;

    ApiService.getAuthenticatedInstance().get(`gallery/exhibition/${this.props.exhibitionId}`)
      .then(response => {
        exhibition = response.data
      })
      .then(() => {
        if (exhibition.locationList[0]) {
          hasLocation = true;
        }

        let carouselMedia = [];

        if (exhibition.videoUrlList) {
          exhibition.videoUrlList
            .map(item => carouselMedia.push({ original: null, thumbnail: null, videoId: item.videoId, type: item.type, file: null }));
        }

        if (exhibition.fileList) {
          exhibition.fileList
            .filter(item => item.usage === FileService.getFileUsage().VIDEO)
            .map(item => carouselMedia.push({ original: null, thumbnail: null, youtubeId: item.youtubeId, type: FileService.getResourceType().VIDEO, file: item }));

          exhibition.fileList
            .filter(item => item.usage === FileService.getFileUsage().THUMBNAIL)
            .map(item => carouselMedia.push({ original: `${ApiService.getBaseUrl()}/storage/file/${item.uuid}`, thumbnail: `${ApiService.getBaseUrl()}/storage/file/${item.uuid}`, youtubeId: null, type: FileService.getResourceType().IMAGE, file: item }));
        }

        this.setState({
          exhibition: exhibition,
          location: exhibition.locationList[0] ? exhibition.locationList[0] : this.state.location,
          freeArtworks: exhibition.freeArtworkList,
          carouselMedia: carouselMedia,
          hasLocation: hasLocation,
          accessDetails: exhibition.exhibitionMembership ? exhibition.exhibitionMembership : null,
          ticket: exhibition.ticket,
          hasTicket: exhibition.ticket ? true : false,
          isLoaded: true
        })
      })
      .catch(err => {
        let errorMessage = "GENERAL.GET_DATA_ERROR";
        if (err && err.response && (err.response.status === 403 || err.response.status === 404)) {
          errorMessage = err.response.data.message
        }
        this.setState({
          isError: true,
          errorMessage: errorMessage,
          isLoaded: true
        })
      })
  }

  async getTicket(paymentType) {
    // let profile = ApiService.getCurrentProfile();
    // if(!profile){
    //   profile = await UserService.getMyProfile().then(response => { return response.data.profile });
    // }

    if (this.state.accessDetails && this.state.accessDetails.accessFee === 0) {
      ApiService.getAuthenticatedInstance().post('/soldTickets', {
        uuid: uuidv4(),
        entity: {
          entityId: this.state.exhibitionId,
          entityName: "EXHIBITION"
        },
        buyer: `/users/${this.state.user.id}`,
        price: this.state.accessDetails.accessFee,
        duration: this.state.accessDetails.accessQuantity,
        status: "SOLD",
        lastUpdatedBy: this.state.user.username,
        lastUpdatedOn: moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ')
      })
        .then(() => {
          toast.success(translatedMessage("EXHIBITION.TICKET.GET_SUCCESS"));
          this.loadData();
        })
        .catch(err => {
          console.log("An error has ocurred: " + err);
          toast.error(translatedMessage("EXHIBITION.TICKET.GET_ERROR"));
        })
    } else {
      this.buyTicket(paymentType);
      // if (!profile.address) {
      //   this.setState({
      //     profile: profile,
      //     addressDialogVisible: true
      //   })
      // }
      // else {
      //   this.setState({
      //     profile: profile
      //   }, this.buyTicket)
      // }
    }
  }

  buyTicket = (paymentType) => {
    PaymentService.createCart(this.state.user, 0)
      .then(cart => {
        const cartId = cart.data._links.self.href.split("/")[cart.data._links.self.href.split("/").length - 1]
        PaymentService.addTicketToCart(this.state.user, cartId, this.state.exhibitionId, "EXHIBITION", this.state.accessDetails)
          .then(response => {
            this.payCartItems(cartId, paymentType);
          }, err => {
            console.log(err);
            toast.error(translatedMessage("CART.ADD_FAIL"));
          });
      }, err => {
        console.log(err);
        toast.error(translatedMessage("CART.ADD_FAIL"));
      });

  }

  payCartItems = (cartId, paymentType) => {
    let formData = new FormData();
    formData.set("cartId", cartId);
    formData.set("paymentType", paymentType);
    formData.set("entityId", this.state.exhibitionId);
    formData.set("entityName", 'EXHIBITION');

    ApiService.getAuthenticatedInstance().post(`/payment/ticket/cart-checkout`, formData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(result => {
      if (result.data.status === "OK") {
        toast.success(translatedMessage("CART.PAYMENT_REDIRECT"));
        window.location.href = result.data.paymentTerminalUrl;
      }
    });
  }

  activateTicket = () => {
    var endTime = moment().add(this.state.ticket.duration, 'hours').format('YYYY-MM-DDTHH:mm:ss.SSSZ')
    var promise = new Promise((resolve, reject) => {
      ApiService.getAuthenticatedInstance().patch(`/soldTickets/${this.state.ticket.id}`, {
        endTime: endTime,
        lastUpdatedBy: ApiService.getCurrentUser().username,
        lastUpdatedOn: moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
      })
        .then(() => resolve())
        .catch(err => reject(err))
    });

    promise.then(() => {
      toast.success(translatedMessage("EXHIBITION.TICKET.START_SUCCESS"));
      this.loadData();
    })
      .catch(err => {
        console.log("An error has ocurred: " + err);
        toast.error(translatedMessage("EXHIBITION.TICKET.START_ERROR"));
      })
  }

  onHideModal = (isSaved) => {
    if (isSaved) {
      UserService.getMyProfile()
        .then(response => {
          let profile = response.data.profile;
          if (profile.address) {
            this.setState({
              profile: profile,
              addressDialogVisible: false
            }, this.buyTicket)
          }
        })
    } else {
      this.setState({
        addressDialogVisible: false
      })
    }
  }


  render() {
    if (!this.state.isLoaded) {
      return (
        <div className="fa-3x w-100 text-center" style={{}}>
          <i className="fa fa-spinner fa-spin"></i>
        </div>
      )
    } else if (!this.state.isError) {
      return (
        <div className="ca-page-padding ca-main-container">
          <Row className="ca-page-title-button-row mb-5">
            <div className="ca-page-title-container d-flex align-items-center">
              <Image src={exhibition} className="ca-page-title-icon" alt={translatedMessage("EXHIBITION.EXHIBITIONS")} />
              <span className="ca-page-title">{this.state.exhibition.name}</span>
            </div>

            <div className="ca-page-title-button-row-buttons">
              <Link to={this.props.artwrokUrl} className="ca-dark-link">
                <Image className="ca-page-title-icon" src={extendedExperience} alt={translatedMessage("ARTWORK.ARTWORKS")}
                  title={translatedMessage("ARTWORK.ARTWORKS")} />
              </Link>

              {this.state.hasLocation && this.state.hasTicket &&
                <Link to={`/exhibition/${this.state.exhibitionId}/map`} className="ca-dark-link">
                  <Image className="ca-page-title-icon" src={map} alt={translatedMessage("MAP.MAP")}
                    title={translatedMessage("MAP.MAP")} />
                </Link>
              }

              <Link to={this.props.backUrl} className="ca-dark-link">
                <Image className="ca-page-title-icon ml-2 mr-0" src={back} alt={translatedMessage("BUTTON.BACK")}
                  title={translatedMessage("BUTTON.BACK")} />
              </Link>
            </div>
          </Row>

          <Row>
            <Col className="col-12 col-lg-6">
              {this.state.location.name &&
                <div className="ca-form-view-field">
                  <div>
                    <span className="ca-label">{translatedMessage("MAP.LOCATION")} </span>
                    <span> - {this.state.location.name}. </span>
                    {this.state.accessDetails && this.state.accessDetails.accessFee !== 0 &&
                      <span className="ca-infotext-small"><br />{translatedMessage("EXHIBITION.LOCATION.INFO")} </span>
                    }
                    {this.state.location?.geofence &&
                      <span className="ca-infotext-small"><br />{translatedMessage("EXHIBITION.GEOFENCE.INFO") + " " + 
                        translatedMessage("EXHIBITION.GEOFENCE.INFO_DETAILS")} </span>
                    }
                  </div>
                </div>
              }

              {this.state.exhibition.startTime &&
                <div className="ca-form-view-field">
                  <div>
                    <span className="ca-label">{translatedMessage("EXHIBITION.AVAILABLE_INTERVAL")} </span>
                    <span>{translatedMessage("GENERAL.INTERVAL_START").toLowerCase()} </span>
                    <i>{moment(this.state.exhibition.startTime).format("MMMM D, YYYY")}</i>
                    {this.state.exhibition.endTime &&
                      <>
                        <span> {translatedMessage("GENERAL.INTERVAL_END").toLowerCase()} </span>
                        <i>{moment(this.state.exhibition.endTime).format("MMMM D, YYYY")}</i>
                      </>
                    }
                  </div>
                </div>
              }

              {!this.state.hasTicket && this.state.accessDetails && this.state.accessDetails.accessFee !== 0 &&
                <div className="ca-form-view-field">
                  <div>
                    {
                      <>
                        <span className="ca-label">{translatedMessage("EXHIBITION.ACCESS_FEE")} </span>
                        <span>{ApiService.getNumberSeparatedByDots(this.state.accessDetails.accessFee) + " USD"}</span>
                        <span className="ca-infotext-small"><br />
                          {this.state.accessDetails.accessType !== null
                            ? (translatedMessage("EXHIBITION.ACCESS_TYPE_HOURS.INFO") + " " + this.state.accessDetails.accessQuantity + " " + translatedMessage(this.state.accessDetails.accessType.label).toLowerCase() + ".")
                            : ""
                          }</span>
                      </>
                    }
                  </div>
                </div>
              }

              <div className="mb-3">
                {this.state.exhibition && this.state.exhibition.status.name === "PUBLISHED" &&
                  <>
                    {!this.state.hasTicket && this.state.accessDetails &&
                      <>
                        {this.state.accessDetails.accessFee === 0 &&
                          <>
                            <div className='mb-3'>
                              <span className="ca-label">{translatedMessage("EXHIBITION.GET_ACCESS")}</span><br />
                              <span className="ca-infotext-small">{translatedMessage("EXHIBITION.GET_ACCESS.FREE.INFO")}</span>
                            </div>
                            <Button variant="dark" className="ca-button" onClick={() => this.getTicket("FREE")}>
                              {translatedMessage("TICKET.FREE")}
                            </Button>
                          </>
                        }
                        {this.state.accessDetails.accessFee !== 0 &&
                          <>
                            <Button variant="dark" className="ca-pay-button" onClick={() => this.getTicket("NETS")}>
                              {translatedMessage("TICKET.BUY")} <FontAwesomeIcon className="ml-2" icon={["fas", "credit-card"]} />
                            </Button>

                            <Button variant="transparent" className="ca-vips-button" onClick={() => this.getTicket("VIPS")}>
                              <svg fill="none" height="44" viewBox="0 0 250 44" width="250" xmlns="http://www.w3.org/2000/svg"><path d="m0 22c0-12.15026 9.84973-22 22-22h206c12.15 0 22 9.84974 22 22 0 12.1503-9.85 22-22 22h-206c-12.15026 0-22-9.8497-22-22z" fill="#ff5b24" /><g fill="#fff"><path d="m52.7131 28.25c2.7822 0 4.4805-1.4092 4.4805-3.7036 0-1.6983-1.2105-2.9629-2.9629-3.1255v-.1626c1.3098-.2078 2.3215-1.4182 2.3215-2.7913 0-2.0053-1.4905-3.2519-3.9656-3.2519h-5.447v13.0349zm-3.2429-11.2192h2.5473c1.4092 0 2.2312.6775 2.2312 1.8427 0 1.1924-.8762 1.8338-2.5293 1.8338h-2.2492zm0 9.4035v-4.0739h2.6196c1.7795 0 2.719.6955 2.719 2.0234 0 1.3369-.9124 2.0505-2.6287 2.0505zm16.2675-.8852c-.3252.7407-1.093 1.1562-2.2041 1.1562-1.4724 0-2.4209-1.0478-2.4751-2.719v-.1174h6.9014v-.7136c0-3.0984-1.6892-4.9683-4.5076-4.9683-2.8635 0-4.6431 1.9963-4.6431 5.167 0 3.1616 1.7525 5.0947 4.6612 5.0947 2.3305 0 3.9836-1.1201 4.3901-2.8996zm-2.2944-5.6187c1.3459 0 2.2312.9485 2.2763 2.448h-4.6521c.0994-1.4814 1.0388-2.448 2.3758-2.448zm7.2795-3.9746v2.4841h-1.5628v1.7434h1.5628v5.4471c0 1.906.9033 2.6648 3.1706 2.6648.4336 0 .8491-.0362 1.1743-.0994v-1.7163c-.271.0271-.4426.0452-.7588.0452-.9394 0-1.3549-.4427-1.3549-1.4273v-4.9141h2.1137v-1.7434h-2.1137v-2.4841zm9.1042 12.4568c1.2917 0 2.3757-.5601 2.9267-1.5176h.1536v1.355h2.1589v-6.7478c0-2.0867-1.4272-3.3152-3.9656-3.3152-2.3486 0-3.9836 1.1021-4.1643 2.8274h2.1138c.2078-.6775.9124-1.0478 1.9421-1.0478 1.2105 0 1.8609.551 1.8609 1.5356v.8491l-2.5474.1536c-2.4028.1355-3.7488 1.1743-3.7488 2.9448 0 1.8066 1.364 2.9629 3.2701 2.9629zm.6594-1.7253c-.9937 0-1.7073-.4969-1.7073-1.346 0-.822.5872-1.2827 1.8428-1.364l2.2312-.1536v.804c0 1.1743-1.0117 2.0596-2.3667 2.0596zm7.1711 1.5627h2.2402v-13.6943h-2.2402zm9.6088 0h2.2402v-6.0071c0-1.2285.8225-2.1589 1.9335-2.1589 1.102 0 1.788.6684 1.788 1.7615v6.4045h2.177v-6.1697c0-1.1291.768-1.9963 1.933-1.9963 1.202 0 1.807.6413 1.807 1.9241v6.2419h2.231v-6.793c0-2.0505-1.192-3.27-3.171-3.27-1.373 0-2.511.7046-2.999 1.7796h-.153c-.416-1.0931-1.364-1.7796-2.728-1.7796-1.31 0-2.322.6685-2.7462 1.7796h-.1536v-1.5899h-2.1589zm23.0067-2.7009c-.326.7407-1.093 1.1562-2.205 1.1562-1.472 0-2.42-1.0478-2.475-2.719v-.1174h6.902v-.7136c0-3.0984-1.689-4.9683-4.508-4.9683-2.863 0-4.643 1.9963-4.643 5.167 0 3.1616 1.753 5.0947 4.661 5.0947 2.331 0 3.984-1.1201 4.39-2.8996zm-2.295-5.6187c1.346 0 2.231.9485 2.276 2.448h-4.652c.1-1.4814 1.039-2.448 2.376-2.448zm10.143 8.4822c1.373 0 2.511-.6414 3.071-1.7253h.154v1.5627h2.168v-13.6943h-2.24v5.3928h-.154c-.524-1.084-1.644-1.7344-2.999-1.7344-2.493 0-4.065 1.9692-4.065 5.0947 0 3.1346 1.563 5.1038 4.065 5.1038zm.696-8.3286c1.535 0 2.484 1.2375 2.484 3.2339 0 2.0053-.94 3.2339-2.484 3.2339-1.536 0-2.466-1.2105-2.466-3.2339 0-2.0144.939-3.2339 2.466-3.2339z" /><path clipRule="evenodd" d="m204.75 20.0884c-.72-2.7477-2.469-3.8384-4.855-3.8384-1.934 0-4.361 1.0907-4.361 3.7172 0 1.6968 1.173 3.0304 3.085 3.374l1.811.323c1.234.2221 1.584.6869 1.584 1.3132 0 .7071-.761 1.111-1.893 1.111-1.481 0-2.406-.5252-2.551-2.0001l-2.612.4042c.411 2.8483 2.962 4.0204 5.266 4.0204 2.181 0 4.505-1.2528 4.505-3.778 0-1.7174-1.049-2.9696-3.003-3.3337l-1.996-.3633c-1.111-.202-1.481-.7475-1.481-1.2727 0-.6668.72-1.0907 1.708-1.0907 1.255 0 2.139.4239 2.18 1.8179zm-58.075 4.3229 2.715-7.8584h3.188l-4.731 11.6565h-2.366l-4.731-11.6563h3.188zm16.683-4.5249c0 .9292-.74 1.5756-1.604 1.5756s-1.605-.6464-1.605-1.5756c0-.9294.741-1.5756 1.605-1.5756s1.605.6462 1.605 1.5756zm.494 4.1213c-1.07 1.3734-2.201 2.3229-4.197 2.323-2.036 0-3.62-1.2121-4.854-2.9897-.494-.7275-1.255-.889-1.811-.5051-.514.3637-.637 1.1314-.164 1.7982 1.707 2.5656 4.073 4.0602 6.829 4.0602 2.531 0 4.506-1.2119 6.048-3.2322.576-.7473.556-1.515 0-1.9393-.514-.4044-1.275-.2624-1.851.4849zm7.098-1.6568c0 2.384 1.399 3.6367 2.962 3.6367 1.481 0 3.004-1.1719 3.004-3.6367 0-2.4244-1.523-3.5959-2.983-3.5959-1.584 0-2.983 1.1111-2.983 3.5959zm0-4.1815v-1.5964h-2.9v15.677h2.9v-5.576c.967 1.2932 2.222 1.8389 3.641 1.8389 2.654 0 5.246-2.0608 5.246-6.3031 0-4.061-2.695-5.9596-4.999-5.9596-1.831 0-3.086.8281-3.888 1.9192zm13.928 4.1815c0 2.384 1.398 3.6367 2.962 3.6367 1.481 0 3.003-1.1719 3.003-3.6367 0-2.4244-1.522-3.5959-2.983-3.5959-1.584 0-2.983 1.1111-2.983 3.5959zm0-4.1815v-1.5964h-.001-2.9v15.677h2.9v-5.576c.967 1.2932 2.222 1.8389 3.641 1.8389 2.654 0 5.246-2.0608 5.246-6.3031 0-4.061-2.695-5.9596-4.999-5.9596-1.831 0-3.085.8281-3.887 1.9192z" fillRule="evenodd" /></g></svg>
                            </Button>
                          </>
                        }
                      </>
                    }
                    {this.state.hasTicket && this.state.accessDetails && this.state.accessDetails.accessType !== null && this.state.ticket.endTime === null &&
                      <span>
                        <Button className="ca-button mb-2" onClick={() => this.activateTicket()}>
                          {translatedMessage("TICKET.START")}
                        </Button>
                        <span className="ca-infotext-small"><br />{translatedMessage("EXHIBITION.TICKET.START_INFO")}
                          <br />
                          {
                            translatedMessage("EXHIBITION.TICKET.START_TIME_INFO") + " " + this.state.accessDetails.accessQuantity + " " +
                            translatedMessage(this.state.accessDetails.accessType.label).toLowerCase()
                          }
                        </span>
                      </span>
                    }
                    {this.state.hasTicket && this.state.accessDetails && (this.state.accessDetails.accessType === null ||
                      (this.state.accessDetails.accessType !== null && this.state.ticket.endTime !== null)) &&
                      <span>
                        {this.state.accessDetails.accessType !== null &&
                          <span className="font-bold"><br />{translatedMessage("TICKET.ACCESS_UNTIL") + " " +
                            moment(this.state.ticket.endTime).format("MMMM D, YYYY HH:mm")}
                          </span>
                        }
                      </span>
                    }
                  </>
                }

                {this.state.freeArtworks.length > 0 &&
                  <div className="ca-form-view-field mt-5">
                    <div>
                      <span className="ca-label">{translatedMessage("EXHIBITION.FREE_ARTWORK")} </span>
                      <span className="ca-infotext-small"><br />{translatedMessage("EXHIBITION.FREE_ARTWORK_INFO")}</span>
                      <div className="col-12 col-sm-6 pl-0 pr-0">
                        {this.state.freeArtworks.map((element, index) => {
                          return (
                            <CardComponent
                              key={index}
                              entity={null}
                              cardImage={ApiService.getThumbnailByUrl(element.id)}
                              cardTitle={element.name}
                              cardAuthor={ArtworkService.getAuthorNameFromMap(element.authorList)}
                              cardCategory={element.category.code}
                              cardId={element.id}
                              cardLink={"#"}
                            />
                          )
                        })}
                      </div>
                    </div>
                  </div>
                }
              </div>
            </Col>
            <Col className="col-12 col-lg-6">
              <Row className="mb-0">
                {this.state.carouselMedia && this.state.carouselMedia.length > 0 &&
                  <Col className="col-12 pl-0 pr-0">
                    <Carousel
                      id="media"
                      items={this.state.carouselMedia}
                      controls={true}
                      indicators={false}
                      interval={null}
                      class="mb-4"
                      hasToolbar={true}
                      toolbarDelete={false}
                      toolbarYoutubeId={false}
                      toolbarFullScreen={true}
                      videoUrlOnly={true}
                    />
                  </Col>
                }
                {this.state.exhibition.description &&
                  <Col className="col-12 pl-0 pr-0">
                    <div className="ca-form-view-field mb-0">
                      <div className="ca-label">{translatedMessage("GENERAL.DESCRIPTION")}</div>
                      <div className="ca-text-justify mb-0" dangerouslySetInnerHTML={{ __html: this.state.exhibition.description }} />
                    </div>
                  </Col>
                }
              </Row>
            </Col>
          </Row>

          <AddUserAddressModal
            show={this.state.addressDialogVisible}
            onHide={this.onHideModal}
            data={this.state.profile}
          />
        </div >
      )
    } else {
      return (
        <ErrorComponent errorMessage={this.state.errorMessage} history={this.props.history} />
      )
    }
  }

}

export default ExhibitionViewComponent;